import { setToken, removeToken, setOTP, removeOTP } from '@/utils/auth'
import Cookies from 'js-cookie'
import addSeconds from 'date-fns/addSeconds'
const domain = require('getdomain')

const actions = {
  set_qrmode({ commit }, QRmode) {
    commit('SET_QRMODE', QRmode)
  },
  disable_table({ commit }, value) {
    commit('SET_DISABLE_TABLE', value)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_disable_table', value)
  },
  saveSelectedType({ commit }, selectedtype) {
    commit('SET_SELECTED_TYPE', selectedtype)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_selected_type', JSON.stringify(selectedtype))
  },
  saveSelectedId({ commit }, selectedid) {
    commit('SET_SELECTED_ID', selectedid)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_selected_id', JSON.stringify(selectedid))
  },
  saveDataCartReservation({ commit }, dataCartReservation) {
    commit('SET_DATA_CART_RESERVATION', dataCartReservation)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_RESERVATION', JSON.stringify(dataCartReservation))
  },
  saveDataCartTakeAway({ commit }, dataCartTakeAway) {
    commit('SET_DATA_CART_OL_TAKE_AWAY', dataCartTakeAway)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_OL-TAKE-AWAY', JSON.stringify(dataCartTakeAway))
  },
  saveDataCartDelivery({ commit }, dataCartDelivery) {
    commit('SET_DATA_CART_DELIVERY', dataCartDelivery)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY', JSON.stringify(dataCartDelivery))
  },
  saveDataCartDineIn({ commit }, dataCartDineIn) {
    commit('SET_DATA_CART_DINE_IN', dataCartDineIn)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN', JSON.stringify(dataCartDineIn))
  },
  removeDataCartReservation({ commit }) {
    commit('SET_DATA_CART_RESERVATION', null)
    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_RESERVATION')
  },
  removeDataCartTakeAway({ commit }) {
    commit('SET_DATA_CART_OL_TAKE_AWAY', null)
    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_OL-TAKE-AWAY')
  },
  removeDataCartDelivery({ commit }) {
    commit('SET_DATA_CART_DELIVERY', null)
    const data_cart = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY'))
    data_cart.item = []
    data_cart.shipping_time = ''
    data_cart.total_amount = 0
    data_cart.notes = ''
    delete data_cart.discount_detail
    delete data_cart.discount_voucher_id
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY', JSON.stringify(data_cart))
  },
  removeDataCartDineIn({ commit }) {
    const data_cart = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN'))
    data_cart.item = []
    delete data_cart.discount_detail
    delete data_cart.discount_voucher_id
    delete data_cart.total_amount
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN', JSON.stringify(data_cart))
    commit('SET_DATA_CART_DINE_IN', data_cart)
    // localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN')
    // commit('SET_DISABLE_TABLE', false)
    // localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_disable_table', false)
  },
  async fetchStore({ commit, state }) {
    try {
      let selectedlocale = Cookies.getJSON(process.env.VUE_APP_COOKIE_KEY + '_locale')
      if (selectedlocale === undefined || selectedlocale == null) {
        selectedlocale = process.env.VUE_APP_I18N_LOCALE
      }
      const { data } = await window.axios({
        method: 'get',
        url: '/store',
        baseURL: process.env.VUE_APP_API_URL + selectedlocale + '/' + state.url_domain
      })
      state.loading_axios = false
      commit('SET_SELECTED_STORE', data.data)
    } catch (e) {
      if (e.isRefreshToken === 1) {
        location.reload()
      }
      commit('FETCH_STORE_FAILURE')
    }
  },
  async checkDomain({ commit, state }) {
    const url_domain = state.url_domain
    if (url_domain === undefined || url_domain === '' || !url_domain) {
      if (process.env.NODE_ENV === 'development') {
        commit('SET_URL_DOMAIN', 'seraqa')
        return true
      } else {
        const curr_domain = domain.get(window.location.href)
        if (curr_domain !== 'antarinmakan.com' && curr_domain !== 'indociti.com') {
          const hostname = domain.hostname(window.location.href)
          const form = {
            domain: hostname
          }
          try {
            let selectedlocale = Cookies.getJSON(process.env.VUE_APP_COOKIE_KEY + '_locale')
            if (selectedlocale === undefined || selectedlocale == null) {
              selectedlocale = process.env.VUE_APP_I18N_LOCALE
            }
            const { data } = await window.axios.post('/' + selectedlocale + '/hintstore', form)
            commit('SET_URL_DOMAIN', data.data.url_id)
            return true
          } catch (e) {
            commit('SET_URL_DOMAIN', '')
            return false
          }
        } else if (curr_domain === 'indociti.com') {
          commit('SET_URL_DOMAIN', 'seraqa')
          return true
        } else {
          var subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false
          commit('SET_URL_DOMAIN', subdomain)
          return true
        }
      }
    }
    return true
  },
  async fetchToken({ commit, state }) {
    try {
      let selectedlocale = Cookies.getJSON(process.env.VUE_APP_COOKIE_KEY + '_locale')
      if (selectedlocale === undefined || selectedlocale == null) {
        selectedlocale = process.env.VUE_APP_I18N_LOCALE
      }
      const { data } = await window.axios({
        method: 'get',
        url: '/system/login',
        baseURL: process.env.VUE_APP_API_URL + selectedlocale + '/' + state.url_domain
      })
      const tokensExpiry = addSeconds(new Date(), data.expires_in)
      data.expires_time = tokensExpiry
      state.loading_axios = false
      commit('SET_TOKEN', data)
      setToken(data.access_token)
      delete data.access_token
      localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_auth_data', JSON.stringify(data))
      return true
    } catch (e) {
      commit('TOKEN_FAILURE')
      if (e.statusCode === 400) {
        return false
      }
      return true
    }
  },
  async fetchOutlet({ commit, state }, obj) {
    try {
      let selectedlocale = Cookies.getJSON(process.env.VUE_APP_COOKIE_KEY + '_locale')
      if (selectedlocale === undefined || selectedlocale == null) {
        selectedlocale = process.env.VUE_APP_I18N_LOCALE
      }
      const { data } = await window.axios({
        method: 'get',
        url: '/outlet/' + obj.id,
        baseURL: process.env.VUE_APP_API_URL + selectedlocale + '/' + state.url_domain
      })
      state.loading_axios = false
      commit('SET_SELECTED_OUTLET', data.data)
    } catch (e) {
      commit('FETCH_OUTLET_FAILURE')
    }
  },
  save_token({ commit }, data) {
    if (data !== '') {
      const tokensExpiry = addSeconds(new Date(), data.expires_in)
      data.expires_time = tokensExpiry
      commit('SET_TOKEN', data)
      setToken(data.access_token)
      delete data.access_token
      localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_auth_data', JSON.stringify(data))
    } else {
      commit('TOKEN_FAILURE')
    }
  },
  remove_token({ commit }) {
    commit('SET_TOKEN', null)
    removeToken()
    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_auth_data')
  },
  create_order({ commit }, data) {
    commit('SET_ORDER', data)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_order', JSON.stringify(data))
  },
  create_history_order({ commit, state }, data) {
    const key = process.env.VUE_APP_COOKIE_KEY + '_history_order'
    let history = JSON.parse(localStorage.getItem(key)) || []
    // masukin data baru di depan
    history.unshift(data)
    // simpan maksimal 3 terakhir
    if (history.length > 3) {
      history = history.slice(0, 3)
    }
    // update ke state
    commit('SET_HISTORY_ORDER', history)
    // update ke localStorage
    localStorage.setItem(key, JSON.stringify(history))
  },
  updateHistoryOrder({ commit }, updatedOrder) {
    const key = process.env.VUE_APP_COOKIE_KEY + '_history_order'
    let history = JSON.parse(localStorage.getItem(key)) || []
    const index = history.findIndex(o => o.id === updatedOrder.id)
    if (index !== -1) {
      // update order lama
      history[index] = updatedOrder
    } else {
      // kalau tidak ketemu, tambahkan ke depan
      history.unshift(updatedOrder)
      if (history.length > 3) {
        history = history.slice(0, 3)
      }
    }
    localStorage.setItem(key, JSON.stringify(history))
    commit('SET_HISTORY_ORDER', history)
  },
  remove_order({ commit }) {
    commit('SET_ORDER', '')
    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_order')
  },
  data_verification({ commit }, data) {
    commit('SET_DATA_VERIFICATION', data)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_data_verification', JSON.stringify(data))
  },
  data_verification_without_save({ commit }, data) {
    commit('SET_DATA_VERIFICATION', data)
  },
  remove_data_verification({ commit }, data) {
    commit('SET_DATA_VERIFICATION', null)
    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_data_verification')
  },
  remove_data_verification_without_save({ commit }, data) {
    commit('SET_DATA_VERIFICATION', null)
  },
  save_type_verification({ commit }, data) {
    commit('SET_TYPE_VERIFICATION', data)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_type_verification', data)
  },
  remove_type_Verification({ commit }) {
    commit('SET_TYPE_VERIFICATION', null)
    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_type_verification')
  },
  set_otp_forget_password({ commit }, data) {
    commit('SET_OTP_FORGET_PASSWORD', data)
    setOTP(data)
  },
  remove_otp_forget_password({ commit }) {
    commit('SET_OTP_FORGET_PASSWORD', null)
    removeOTP()
  },
  removeErrors({ commit }) {
    commit('REMOVE_ERROR')
  },
  saveCartV2({ commit }, data) {
    commit('SAVE_CART_V2', data)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart', JSON.stringify(data))
  },
  removeCartV2({ commit }) {
    const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
    let cart = {}
    if (LOCAL_DATA_CART) {
      cart = { ...JSON.parse(LOCAL_DATA_CART) }
      if (typeof cart.discount_detail !== 'undefined') {
        delete cart.discount_detail
      }
      if (typeof cart.discount_voucher_id !== 'undefined') {
        delete cart.discount_voucher_id
      }
      if (typeof cart.point_detail !== 'undefined') {
        delete cart.point_detail
      }
      if (typeof cart.redeemId !== 'undefined') {
        delete cart.redeemId
      }
      if (typeof cart.requestId !== 'undefined') {
        delete cart.requestId
      }
      if (typeof cart.total_pay !== 'undefined') {
        delete cart.total_pay
      }
      if (typeof cart.previousOrderId !== 'undefined') {
        delete cart.previousOrderId
      }
      cart.item = []
    }
    commit('SAVE_CART_V2', cart)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart', JSON.stringify(cart))
  },
  saveIdOrder({ commit }, data) {
    commit('SET_ID_ORDER_V2', data)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_v2_id', data)
  },
  saveLocationV2({ commit }, data) {
    commit('SAVE_LOCATION_V2', data)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_v2_location', JSON.stringify(data))
  },
  saveShippingV2({ commit }, data) {
    commit('SAVE_SHIPPING_V2', data)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_v2_shipping', JSON.stringify(data))
  },
  saveTableV2({ commit }, data) {
    commit('SAVE_TABLE_V2', data)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_v2_table', JSON.stringify(data))
  },
  saveDetailReservationV2({ commit }, data) {
    commit('SAVE_DETAIL_RESERVATION_V2', data)
    localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_v2_detail_reservation', JSON.stringify(data))
  },
  delShippingV2({ commit }) {
    commit('DELETE_SHIPPING_V2')
    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_v2_shipping')
  },
  delDetailReservationV2({ commit }) {
    commit('DELETE_DETAIL_RESERVATION_V2')
    localStorage.removeItem(process.env.VUE_APP_COOKIE_KEY + '_v2_detail_reservation')
  }
}
export default actions
